var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: { "is-modified": !!_vm.value, half: _vm.half, label: "送信回数" },
    },
    [
      _c("input", {
        staticClass: "boss-input boss-send-count",
        attrs: {
          type: "number",
          max: Number.MAX_SAFE_INTEGER,
          min: "0",
          "data-test": "text-box",
        },
        domProps: { value: _vm.value },
        on: {
          keypress: function ($event) {
            return _vm.onlyNumberInRange($event)
          },
          input: function ($event) {
            _vm.$emit("input", Number($event.target.value) || null)
          },
        },
      }),
      _vm._v(" "),
      _c("span", [_vm._v("回")]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }